import { useEffect, useState } from 'react';

const messagesByCountry = {
  BR: ['Ainda planejando sua viagem?', 'Venha conhecer Jardim da Amazônia'],
  DEFAULT: ['Still planning your trip?', 'Come visit Jardim da Amazônia'],
};

export default function TabTitleEffect() {
  const [messages, setMessages] = useState(messagesByCountry.DEFAULT);

  useEffect(() => {
    // Fetch country code using a public IP geolocation API
    fetch('https://ipapi.co/country/')
      .then((res) => res.text())
      .then((countryCode) => {
        if (countryCode === 'BR') {
          setMessages(messagesByCountry.BR);
        } else {
          setMessages(messagesByCountry.DEFAULT);
        }
      })
      .catch(() => {
        setMessages(messagesByCountry.DEFAULT);
      });
  }, []);

  useEffect(() => {
    let originalTitle = document.title;
    let interval = null;
    let messageIndex = 0;

    function handleVisibilityChange() {
      if (document.hidden) {
        interval = setInterval(() => {
          document.title = messages[messageIndex];
          messageIndex = (messageIndex + 1) % messages.length;
        }, 5000);
      } else {
        clearInterval(interval);
        interval = null;
        document.title = originalTitle;
        messageIndex = 0;
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (interval) clearInterval(interval);
      document.title = originalTitle;
    };
  }, [messages]);

  return null;
} 